import { LayoutDashboard, BookOpen, TrendingUp } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type ViewKey = 'dashboard' | 'library' | 'progress';

interface NavItem {
  key: ViewKey;
  label: string;
  Icon: LucideIcon;
}

const ITEMS: readonly NavItem[] = [
  { key: 'dashboard', label: 'Dashboard', Icon: LayoutDashboard },
  { key: 'library', label: 'Bibliothek', Icon: BookOpen },
  { key: 'progress', label: 'Fortschritt', Icon: TrendingUp },
] as const;

interface BottomNavProps {
  active: ViewKey;
  onChange: (next: ViewKey) => void;
}

export function BottomNav({ active, onChange }: BottomNavProps): JSX.Element {
  return (
    <nav
      aria-label="Hauptnavigation"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-zinc-200 bg-white pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="mx-auto flex max-w-3xl items-stretch">
        {ITEMS.map(({ key, label, Icon }) => {
          const isActive = key === active;
          return (
            <li key={key} className="flex-1">
              <button
                type="button"
                onClick={() => onChange(key)}
                aria-current={isActive ? 'page' : undefined}
                aria-label={label}
                className={`flex h-16 w-full flex-col items-center justify-center gap-1 transition-transform duration-[120ms] active:scale-[0.97] focus-visible:outline-2 focus-visible:outline-emerald-500 focus-visible:outline-offset-[-2px] ${
                  isActive ? 'text-emerald-600' : 'text-zinc-600'
                }`}
              >
                <Icon
                  aria-hidden="true"
                  className={`size-6 ${isActive ? 'fill-emerald-100 stroke-[2.25]' : ''}`}
                />
                <span className={`text-xs ${isActive ? 'font-semibold' : 'font-normal'}`}>
                  {label}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
